$(function() {
    $('[data-map]').each(function() {
        init(this);
    });

    function init(el) {
        var defaultLatLng = { lat: 41.551029, lng: -8.428204 };
        var map = new google.maps.Map(el, {
            center: defaultLatLng,
            zoom: 6
        });
        map.setOptions({draggable: true, zoomControl: true, scrollwheel: false, disableDoubleClickZoom: false});

        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                map.setCenter({ lat: position.coords.latitude, lng: position.coords.longitude });
                map.setZoom(15);
            });
        }
    }
});